// src/pages/Home.js
import React from 'react';
import ContactForm from '../components/contact-page-component/contact-form';
function Contact() {
  return (
    <ContactForm />
  );
}

export default Contact;